<template>
  <div class="dialog-page">
    <div class="dialog">
      <div class="msg">{{ msg }}</div>
      <div class="time" v-if="type === 'timeout'">
        <img
          class="btn time-btn"
          @click="close"
          src="../assets/images/sure_time.png"
        />
        <span class="time-tip">(2s)</span>
      </div>
      <img class="btn" @click="close" v-else src="../assets/images/sure.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    msg: String,
    type: String
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/theme.less';
.dialog-page {
  position: absolute;
  width: 100vw;
  height: 100vh;
  .dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 2.95rem;
    height: 2.38rem;
    background-image: url(../assets/images/tips.png);
    background-size: contain;
    background-repeat: no-repeat;
    padding: 0.8rem 0;
    .msg {
      width: 2.9rem;
      //white-space: pre;
      text-align: center;
      font-size: 0.21rem;
      //line-height: 0.32rem;
      margin-bottom: 0.15rem;
    }
    .btn {
      width: 1rem;
      // height: 0.4rem;
    }
    .time {
      position: relative;
    }
    .time-btn {
      width: 1.31rem;
    }
    .time-tip {
      position: absolute;
      left: 0.7rem;
      top: 0.01rem;
      font-size: 0.2rem;
      font-weight: 100;
      color: white;
    }
  }
}

/* 移动端  */
@media all and (max-width: 768px) {
  .dialog-page {
    .dialog {
      width: 7.26rem;
      height: 5.85rem;
      padding: 2.1rem 0;
      .msg {
        width: 7rem;
        //white-space: pre;
        text-align: center;
        font-size: 0.4rem;
        //line-height: 0.5rem;
        margin-bottom: 0.5rem;
      }
      .btn {
        width: 2rem;
        // height: 0.4rem;
      }
      .time-btn {
        width: 2.6rem;
      }
      .time-tip {
        left: 1.4rem;
        top: 0.03rem;
        font-size: 0.4rem;
      }
    }
  }
}
</style>
